// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2MK2I","col":"Table_col__1k7v1","fulfillmentStatus":"Table_fulfillmentStatus__1_kWO","emailCol":"Table_emailCol__2UmY8"};